/*******************************************************************************
 * grid.js - Grid Functions and Event Handlers
 ******************************************************************************/

import { ELEMENT_IDS, STORAGE_KEYS } from './constants.js';
import { getElement, getGrid, formatCurrency, findRowIndexById } from './utils.js';
import { getFromStorage, saveToStorage, removeFromStorage } from './storage.js';
import state, { getState, setState } from './state.js';

/**
 * Before data bound event handler
 */
export function BeforeDataBound() {
    var grid = getElement("Grid").ej2_instances[0];
    grid.height = state.windowHeight - 290;
    grid.width = state.windowWidth - 25;
    grid.showSpinner();
    
    var subscriptionID;
    if (typeof expireOrganization !== 'undefined' && expireOrganization.length > 0) {
        var content = expireOrganization;
        var dataArray = content.split(",");
        console.log(dataArray);
        console.log(dataArray.join("\n"));

        dataArray.forEach(function(item, index) {
            var splitCode = item.split(":");
            subscriptionID = splitCode[2];
        });
    }
    
    // Load the saved selection from localStorage
    var existingSelection = getFromStorage(STORAGE_KEYS.SELECTED_DATA);
    console.log("existingSelectionOrgId", existingSelection.orgId);
    
    // Apply the saved selection to the grid
    var filteredSelection = existingSelection.filter(function (item) {
        return item.orgId === subscriptionID;
    });
}

/**
 * Data source changed event handler
 */
export function DataSourceChanged() {
    var grid = getElement("Grid").ej2_instances[0];
    grid.showSpinner();
}

/**
 * Data state change event handler
 */
export function DataStateChange() {
    var grid = getElement("Grid").ej2_instances[0];
    grid.showSpinner();
}

/**
 * Modal created callback
 */
export function modalCreated() {
    setState('dialogObj', this);
    this.hide();
}

/**
 * Update pagination template
 */
export function updateTemplate() {
    var grid = getElement("Grid").ej2_instances[0];

    let defaultPageSizes = ["500", "1000", "1500", "2000"];
    var existingSelection = getFromStorage(STORAGE_KEYS.SELECTED_DATA);
    var subscriptionID = getState('subscriptionID');
    const filteredExistingSelection = existingSelection.filter(record => record.orgId === subscriptionID);
    
    var selectedPageSizes = getState('selectedPageSizes');
    var selectedPageSize = getState('selectedPageSize');
    
    if (selectedPageSizes == undefined) {
        if (filteredExistingSelection.length > 0) {
            if (filteredExistingSelection.length <= 500) {
                selectedPageSizes = 500;
                selectedPageSize = 500;
            } else if (filteredExistingSelection.length > 500 && filteredExistingSelection.length <= 1000) {
                selectedPageSizes = 1000;
                selectedPageSize = 1000;
            } else if (filteredExistingSelection.length > 1000 && filteredExistingSelection.length <= 1500) {
                selectedPageSizes = 1500;
                selectedPageSize = 1500;
            } else if (filteredExistingSelection.length > 1500 && filteredExistingSelection.length <= 2000) {
                selectedPageSizes = 2000;
                selectedPageSize = 2000;
            } else if (filteredExistingSelection.length > 2000 && filteredExistingSelection.length <= 2500) {
                selectedPageSizes = 2500;
                selectedPageSize = 2500;
            } else if (filteredExistingSelection.length > 2500 && filteredExistingSelection.length <= 3000) {
                selectedPageSizes = 3000;
                selectedPageSize = 3000;
            } else if (filteredExistingSelection.length > 3000 && filteredExistingSelection.length <= 3500) {
                selectedPageSizes = 3500;
                selectedPageSize = 3500;
            } else if (filteredExistingSelection.length > 3500 && filteredExistingSelection.length <= 4000) {
                selectedPageSizes = 4000;
                selectedPageSize = 4000;
            } else if (filteredExistingSelection.length > 4000 && filteredExistingSelection.length <= 4500) {
                selectedPageSizes = 4500;
                selectedPageSize = 4500;
            } else {
                selectedPageSizes = 5000;
                selectedPageSize = 5000;
            }
        } else {
            selectedPageSize = 500;
            selectedPageSizes = 500;
        }
        setState('selectedPageSizes', selectedPageSizes);
        setState('selectedPageSize', selectedPageSize);
    }
    
    var dropdown = getElement("customPager");
    dropdown.value = selectedPageSizes;

    getElement("btnNextPage").onclick = function (e) {
        var currentPageValue = parseInt(getElement("currentPage").value, 10) + 1;
        grid.goToPage(currentPageValue);
    };

    getElement("btnLastPage").onclick = function (e) {
        var currentPageValue = parseInt(getElement("currentPage").value, 10) - 1;
        grid.goToPage(currentPageValue);
    };
}

/**
 * Action complete event handler for invoice grid
 * @param {object} args - Event arguments
 */
export function actionCompleteInvoiceGrid(args) {
    var grid = getGrid(ELEMENT_IDS.GRID_SORTING);
    if (!grid) return;
    
    grid.hideSpinner();

    if (args.action === 'edit') {
        var billsSelected = this.getSelectedRecords();
        setState('billsSelected', billsSelected);
        var total = 0;

        billsSelected.forEach((item) => {
            total += item.amountDueEditable;
        });
        setState('total', total);
        
        if (typeof countryCode !== 'undefined' && countryCode == "GB") {
            getElement("total").innerHTML = "£" + total.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        } else {
            getElement("total").innerHTML = "$" + total.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        }
    }

    if (args.requestType === 'paging') {
        updateTemplate();
    }

    if (args.requestType === 'refresh') {
        updateTemplate();
    }
}

/**
 * Value accessor function for planned date
 * @param {string} field - Field name
 * @param {object} data - Row data
 * @param {object} column - Column definition
 * @returns {Date|string} - Formatted date or empty string
 */
export function valueAccessorFn(field, data, column) {
    var value = data[field];
    if (data['plannedDate'] !== undefined || data['plannedDate'] !== null) {
        value = new Date(data['plannedDate']);
        if (value.getFullYear() == 1970) {
            return '';
        }
        return value;
    } else {
        return '';
    }
}

/**
 * Current page change handler
 */
export function currentPageChange() {
    var grid = getElement("Grid").ej2_instances[0];
    this.value = parseInt(this.value, 10) > parseInt(this.max, 10) ? this.max : this.value;
    var pageNumber = parseInt(this.value, 10);
    grid.goToPage(pageNumber);
}

/**
 * Cell saved event handler
 * @param {object} e - Event arguments
 */
export function cellSaved(e) {
    setState('cellEditRowIndex', null);
}

/**
 * Key down handler for grid
 * @param {object} e - Event arguments
 */
export function keyDownHandler(e) {
    if (e.keyCode === 9) {
        e.cancel = true;
    }
}

/**
 * Cell edit event handler
 * @param {object} args - Event arguments
 */
export function cellEdit(args) {
    setState('cellEditRowIndex', args.rowIndex);
}

/**
 * Validate pay now
 * @param {object} args - Arguments
 * @param {object} column - Column
 * @param {Array} records - Records
 */
export function validatePayNow(args, column, records) {
    // Implementation placeholder
}

/**
 * Grid render event handler
 * @param {object} args - Event arguments
 */
export function onGridRender(args) {
    var grid = getElement("Grid").ej2_instances[0];
    grid.hideSpinner();
    
    // Get stored selection
    var storedData = getFromStorage(STORAGE_KEYS.SELECTED_DATA);
    var subscriptionID = getState('subscriptionID');
    
    if (storedData && storedData.length > 0) {
        const filteredData = storedData.filter(item => item.orgId === subscriptionID);
        if (filteredData.length > 0) {
            updateGridSelectionAndData();
        }
    }
}

/**
 * Update grid selection and data
 */
export function updateGridSelectionAndData() {
    const gridInstance = getElement('Grid').ej2_instances[0];
    getElement("spinnerGlobal").style.visibility = "visible";

    if (gridInstance) {
        const dataSource = gridInstance.dataSource;
        const currentPage = gridInstance.pageSettings.currentPage;
        const pageSize = gridInstance.pageSettings.pageSize;
        const startIndex = (currentPage - 1) * pageSize;
        const endIndex = startIndex + pageSize;

        const currentPageData = dataSource.slice(startIndex, endIndex);
        const idToIndexMap = new Map(currentPageData.map((item, index) => [item.invoiceID, startIndex + index]));

        const selectedIndexes = [];
        const storedData = getFromStorage(STORAGE_KEYS.SELECTED_DATA);

        storedData.forEach(data => {
            const index = idToIndexMap.get(data.invoiceID);
            if (index !== undefined) {
                selectedIndexes.push(index);
            }
        });

        gridInstance.clearSelection();
        gridInstance.selectRows(selectedIndexes, true);
        gridInstance.refresh();

        setTimeout(() => {
            getElement("spinnerGlobal").style.visibility = "hidden";
            gridInstance.hideSpinner();
        }, 500);
    } else {
        console.error("Grid instance is not initialized.");
        getElement("spinnerGlobal").style.visibility = "hidden";
    }
}

/**
 * Apply selection to grid
 * @param {Array} selection - Selected items
 */
export function applySelectionToGrid(selection) {
    var gridInstance = getElement('Grid').ej2_instances[0];

    var rowIndices = [];

    selection.forEach(function (selectedItem) {
        const rowIndex = findRowIndexById(gridInstance, selectedItem.invoiceID);

        if (rowIndex !== -1) {
            rowIndices.push(rowIndex);
        }
    });

    if (rowIndices.length > 0) {
        rowIndices.forEach(rowIndex => gridInstance.selectionModule.selectRow(rowIndex));
    } else {
        console.log('No rows selected.');
    }
}

/**
 * Delete search - clears the search input and resets the grid filter
 */
export function deleteSearch() {
    var searchElement = getElement('inputSearchTxtbox');
    if (searchElement) {
        searchElement.value = '';
        var grid = getElement('Grid');
        if (grid && grid.ej2_instances && grid.ej2_instances[0]) {
            grid.ej2_instances[0].search('');
        }
    }
}

/**
 * Grid selection save function (attached to window)
 * @param {Array} selectedData - Selected data to save
 */
export function gridSelectionSaveSelection(selectedData) {
    saveToStorage(STORAGE_KEYS.SELECTED_DATA, selectedData);
}

/**
 * Get subscription ID from expire organization string
 * @param {string} expireOrg - Expire organization string
 * @returns {string|null} - Subscription ID
 */
export function getSubscriptionIDFromExpireOrganization(expireOrg) {
    if (!expireOrg || expireOrg.length === 0) return null;
    var dataArray = expireOrg.split(",");
    var subId = null;
    dataArray.forEach(function(item) {
        var splitCode = item.split(":");
        subId = splitCode[2];
    });
    return subId;
}

/*******************************************************************************
 * WINDOW ASSIGNMENTS - Replace stubs with actual implementations
 ******************************************************************************/
window.actionCompleteInvoiceGrid = actionCompleteInvoiceGrid;
window.valueAccessorFn = valueAccessorFn;
window.validatePayNow = validatePayNow;
window.BeforeDataBound = BeforeDataBound;
window.DataSourceChanged = DataSourceChanged;
window.DataStateChange = DataStateChange;
window.modalCreated = modalCreated;
window.updateTemplate = updateTemplate;
window.currentPageChange = currentPageChange;
window.cellSaved = cellSaved;
window.keyDownHandler = keyDownHandler;
window.cellEdit = cellEdit;
window.onGridRender = onGridRender;
window.updateGridSelectionAndData = updateGridSelectionAndData;
window.applySelectionToGrid = applySelectionToGrid;
window.deleteSearch = deleteSearch;
window.gridSelectionSaveSelection = gridSelectionSaveSelection;
window.getSubscriptionIDFromExpireOrganization = getSubscriptionIDFromExpireOrganization;
